import React from 'react';
import Banner from '@components/sec_banner/component';
import DynamicBanner from '@components/sec_dynamic-banner/component';
import Bestsellers from '@components/sec_bestsellers/component';
import GenreList from '@components/sec_genre-list/component';
import Bookskyline from '@components/sec_bookskyline/component';
import AnkeilerGrid from '@components/sec_ankeiler-grid/component';
import CategoryCollectionList from '@components/sec_category-collection-list/component';
import TegelGenreBanner from '@components/sec_tegel-genre-banner/component';
import Grid from '@components/sec_grid/component';
import Markdown from '@components/sec_markdown/component';
import DynamicComponent from '@components/sec_dynamic-component/component';
import store from '@utils/store';

const componentToDOM = (component, index = 0, props) => {
  if (!component) {
    return null;
  }

  const componentMap = {
    banner: Banner,
    dynamicBanner: DynamicBanner,
    bestsellers: Bestsellers,
    commonMarkdown: Markdown,
    genreList: GenreList,
    ankeilerGrid: AnkeilerGrid,
    bookskyline: Bookskyline,
    genreCategoryListDetails: CategoryCollectionList,
    ankilerpromos: Grid,
    grid: Grid,
    tegelGenreBanner: TegelGenreBanner,
    dynamicComponent: DynamicComponent,
  };

  const Component = componentMap[component['component-type']];
  if (Component) {
    const props = { ...component, ...props };
    return <Component store={store} {...props}>{component.children}</Component>;
  }
  return null;
};

export default componentToDOM;
